<template>
    <div>
        <form class="subscribe-form" @submit.prevent="sendForm" v-if="!isFormHidden">
            <div class="subscribe-form__container" v-if="!edit">
                <label class="subscribe-form__label" for="subscribe-email">{{ text.labelEmail[lang] }}</label>
                <input
                    id="subscribe-email"
                    type="text"
                    class="subscribe-form__field"
                    v-model="params.email"
                    @input="checkEmail"
                    @blur="checkEmail"
                    @focus="clearEmailError"
                >
                <span class="subscribe-form__error" v-if="error.email">
                    <span v-html="error.email"></span>
                </span>
            </div>
            <div class="subscribe-form__container">
                <label class="subscribe-form__checkbox" v-for="item in rubrics" :key="item.id">
                    <input
                        class="subscribe-form__checkbox-input"
                        type="checkbox"
                        :value="Number(item.id)"
                        v-model="params.rubrics"
                    >
                    <span class="subscribe-form__checkbox-box"></span>
                    <div class="subscribe-form__checkbox-info">
                        <span class="subscribe-form__checkbox-title" v-html="item.name"></span>
                        <p class="subscribe-form__checkbox-text" v-html="item.description"></p>
                    </div>
                </label>
                <span class="subscribe-form__error"></span>
            </div>
            <div class="subscribe-form__container" v-if="!edit">
                <label class="subscribe-form__checkbox">
                    <input class="subscribe-form__checkbox-input" type="checkbox" v-model="params.agreement">
                    <span class="subscribe-form__checkbox-box"></span>
                    <div class="subscribe-form__checkbox-info">
                        <p class="subscribe-form__checkbox-text" v-html="text.agreement[lang]"></p>
                    </div>
                </label>
                <span class="subscribe-form__error"></span>
            </div>
            <button
                type="submit"
                :class="['subscribe-form__btn btn', { 'subscribe-form__btn--disabled' : !isSubmitAvalible }]"
                :disabled="!isSubmitAvalible"
            >
                <span v-html="text.submitBtn[lang]"></span>
            </button>
        </form>

        <template v-if="isSendSuccess">
            <p
                :class="['subscribe-form-msg', { 'subscribe-form-msg--green' : edit }]"
            >
                <span v-html="successMsg"></span>
            </p>
        </template>

        <div class="subscribe-social">
            <p v-html="text.socialLinksText[lang]"></p>
            <ul class="subscribe-social__list">
                <li class="subscribe-social__item">
                    <a href="https://www.facebook.com/gazprom.neft" target="_blank" class="subscribe-social__link">
                        <span class="subscribe-social__icon subscribe-social__icon--fb"></span>
                        <span class="subscribe-social__text">Facebook</span>
                    </a>
                </li>
                <li class="subscribe-social__item">
                    <a href="https://vk.com/gazprom_neft" target="_blank" class="subscribe-social__link">
                        <span class="subscribe-social__icon subscribe-social__icon--vk"></span>
                        <span class="subscribe-social__text">Вконтакте</span>
                    </a>
                </li>
                <li class="subscribe-social__item">
                    <a href="https://www.youtube.com/user/GAZPROMNEFT" target="_blank" class="subscribe-social__link">
                        <span class="subscribe-social__icon subscribe-social__icon--youtube"></span>
                        <span class="subscribe-social__text">Youtube</span>
                    </a>
                </li>
                <li class="subscribe-social__item">
                    <a href="https://www.instagram.com/gazprom_neft.ru/" target="_blank" class="subscribe-social__link">
                        <span class="subscribe-social__icon subscribe-social__icon--inst"></span>
                        <span class="subscribe-social__text">Instagram</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { fetch as fetchPolyfill } from 'whatwg-fetch';

export default {
    name: 'subscribe-form',
    props: {
        edit: {
            type: Boolean,
            default: false
        },
        initial: {
            type: Object
        }
    },
    data () {
        return {
            apiUrl: {
                add: '/api/subscribe/add',
                edit: '/api/subscribe/edit'
            },
            rubrics: App.components["subscribe-rubrics"],
            error: {
                email: null
            },
            text: {
                agreement: {
                    ru: 'Я ознакомлен(-а) с <a href="/terms/" target="_blank">Положением о конфиденциальности</a> и даю согласие на передачу и обработку моих персональных данных',
                    en: 'I have read the <a href="/terms/" target="_blank">Privacy Regulations</a> and I consent to the transfer and processing of my personal data.'
                },
                submitBtn: {
                    ru: 'Сохранить',
                    en: 'Save'
                },
                labelEmail: {
                    ru: 'Ваш e-mail',
                    en: 'E-mail'
                },
                error: {
                    email: {
                        empty: {
                            ru: 'Пожалуйста, укажите ваш Email',
                            en: 'Enter your e-mail'
                        },
                        incorrect: {
                            ru: 'Неверный формат e-mail',
                            en: 'Enter your e-mail correctly'
                        }
                    }
                },
                successMsg: '', //приходит с бека
                socialLinksText: {
                    ru: 'Следите за новостями в наших соцсетях:',
                    en: 'Follow the news on our social networks:'
                }
            },
            params: {
                email: '',
                rubrics: [],
                agreement: false
            },
            isFormHidden: false,
            isSendSuccess: false
        }
    },
    computed: {
        lang () {
            return getLang()
        },
        isSubmitAvalible () {
            if (!this.edit) {
                return this.validateEmail(this.params.email) &&
                    this.params.rubrics.length &&
                    this.params.agreement
            } else {
                return true
            }
        }
    },
    methods: {
        sendForm () {
            let url
            this.edit ? url = this.apiUrl.edit : url = this.apiUrl.add

            let formData = new FormData();
            for (let key in this.params) {
                if (Array.isArray(this.params[key])) {
                    this.params[key].forEach((item) => {
                        formData.append(`${key}[]`, item)
                    });

                } else {
                    formData.append(key, this.params[key])
                }
            }

            fetch(url, {
                method: 'POST',
                body: formData
            })
                .then(
                    response => {
                      if (response.ok) {
                        return response.json();
                      }
                      throw new Error('Request failed!');
                    },
                    networkError => console.log(networkError.message)
                )
                .then(
                    jsonResponse => {
                        if (jsonResponse.status === 'error') {
                            this.error.email =  jsonResponse.message
                        } else {
                            this.isSendSuccess = true
                            this.successMsg = jsonResponse.message
                            this.edit ? this.isFormHidden = false : this.isFormHidden = true
                        }
                    }
                )
        },
        checkEmail () {
            if (this.params.email !== '') {
                this.validateEmail(this.params.email) ? this.error.email = '' : this.error.email = this.text.error.email.incorrect[this.lang]
            } else {
                this.error.email = this.text.error.email.empty[this.lang]
            }
        },
        clearEmailError () {
            this.error.email = ''
        },
        validateEmail (email) {
            // eslint-disable-next-line no-useless-escape
            let regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return regex.test(email)
        }
    },
    created () {
        if (this.edit) {

            this.rubrics.forEach((item) => {
                if (item.selected) {
                    this.params.rubrics.push(Number(item.id))
                }
            });

            let params = Object.assign({}, this.params);
            params['CONFIRM_CODE'] = App.system.params.get['CONFIRM_CODE']
            params['ID'] = App.system.params.get['ID']

            this.params = params
        }
            
        if (this.initial.email) {
            this.params.email = this.initial.email
        }

        if (this.initial.rubrics) {
            this.params.rubrics = this.initial.rubrics
        }
    }
}
</script>



// WEBPACK FOOTER //
// frontend/components/subscribtion/subscribtion.vue